import {BaseFormModel} from '../base-form-model';
import {Column} from './column';
import {Filter} from './filter';
import {Sort} from './sort';
import {TabReportEmail} from './tab-report-email';

export class TabReport extends BaseFormModel<TabReport> {
    id: number;
    title: string;
    comparisonDateKey: string;
    description: string;
    rowKey: string;
    startTime: Date;
    endTime: Date;
    columns: Column[];
    optionalFilters: Filter[];
    baseFilters: Filter[];
    sort: Sort[];
    orgId: number;
    venueId: number;
    parentId: number;
    durationPart: string;
    durationCount: number;
    tabReportEmail: TabReportEmail;

    selected: boolean;

    public constructor(jsonInput: any) {
        super(jsonInput);
        Object.assign(this, jsonInput);

        const columns = [];
        if (this.columns) {
            this.columns.forEach(sel => {
                columns.push(new Column(sel));
            });
        }
        this.columns = columns;

        const baseFilters = [];
        if (this.baseFilters) {
            this.baseFilters.forEach(f => {
                baseFilters.push(new Filter(f));
            });
        }
        this.baseFilters = baseFilters;

        const sorts = [];
        if (this.sort) {
            this.sort.forEach(s => {
                sorts.push(new Sort(s));
            });
        }
        this.sort = sorts;

        this.tabReportEmail = !!this.tabReportEmail ? new TabReportEmail(this.tabReportEmail) : null;
    }
}
